import { FormPageInputItemNumberAttitudeScale } from 'backend';
import {
  FormPageAuthInputItemNumberFree,
  FormPageInputItemNumberAdditionalText,
} from 'shared';

const convertNumberFree = (value?: string): string | undefined => {
  if (value === '') {
    return undefined;
  }
  return value;
};

export const convertNumberAdditionalText = (
  value: FormPageInputItemNumberAdditionalText,
): string | undefined => {
  return convertNumberFree(value.number);
};

export const convertNumverAttitudeScale = (
  value: FormPageInputItemNumberAttitudeScale,
): string | undefined => {
  return convertNumberFree(value.number);
};

export const convertAuthNumberFree = (
  value: FormPageAuthInputItemNumberFree,
): string | undefined => {
  return convertNumberFree(value.number);
};
